// helpers/addToCart.js
import { toast } from "react-toastify";
import { summaryApi } from "../common";

const addToCart = async(e, productData, fetchUserAddToCart) => {
    e.preventDefault();
    e?.stopPropagation()

    try {
        // Handle case where only productId string is passed
        let cartData;
        
        if (typeof productData === 'string') {
            // If only ID is passed, create basic cart data
            cartData = {
                productId: productData,
                storage: '',
                color: '',
                ram: '',
                processor: '',
                screenSize: ''
            };
        } else {
            // If full product data object is passed
            cartData = {
                productId: productData.productId || productData._id, // Support both productId and _id
                storage: productData.storage || '',
                color: productData.color || '',
                ram: productData.ram || '',
                processor: productData.processor || '',
                screenSize: productData.screenSize || ''
            };
        }

        const response = await fetch(summaryApi.addToCart.url, {
            method: summaryApi.addToCart.method,
            
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(cartData)
        });

        const responseData = await response.json();
        
        if(responseData.success){
            fetchUserAddToCart();
            toast.success(responseData.message)
        } else {
            toast.error(responseData.message || "Failed to add to cart")
        }

    } catch (error) {
        toast.error(error.message)
        console.log("Error in addToCart", error)        
    }
}

export default addToCart;